import { useLoad } from "@redotech/react-util/load";
import {
  ActivityStatus,
  Workflow,
} from "@redotech/redo-return-core-common/returns/temporal-status";
import { useContext, useState } from "react";
import { RpcClientContext } from "../../contexts/rpc";

export interface UseCreationStatusResult {
  creationStatus:
    | {
        activityStatuses: (
          | Extract<
              ActivityStatus,
              { workflow: Workflow.RETURN_CREATION_SIDE_EFFECTS }
            >
          | Extract<
              ActivityStatus,
              { workflow: Workflow.RETURN_READY_SIDE_EFFECTS }
            >
        )[];
        workflowStartTime?: Date | undefined | null;
        isWorkflowRunning?: boolean;
      }
    | undefined;
  completelyFinished: boolean;
}

export const useCreationStatus = ({
  returnId,
}: {
  returnId: string;
}): UseCreationStatusResult => {
  const client = useContext(RpcClientContext);

  const [creationStatus, setCreationStatus] =
    useState<UseCreationStatusResult["creationStatus"]>(undefined);

  const [completelyFinished, setCompletelyFinished] = useState(false);

  useLoad(
    async (signal) => {
      if (!client || !returnId) {
        return;
      }

      try {
        const iterator = client.getReturnCreationStatus({ returnId });

        for await (const creationStatus of iterator) {
          setCreationStatus(creationStatus);
          setCompletelyFinished(creationStatus.isWorkflowRunning === false);
        }
      } catch (e) {
        if (signal.aborted) {
          return;
        }
        throw e;
      }
    },
    [client, returnId],
  );

  return { creationStatus, completelyFinished };
};
